import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";

// Renders the sign-in pages at once and redirects only once it knows where to
// send a signed-in user. It never shows a placeholder instead of the page:
// restoring an expired session goes over the network to the auth server, and
// when that server hangs the page used to stay blank for as long as the request
// did (90 s and more during the 2026-10-26 outage). A signed-in visitor sees the
// form for a moment, then is sent on.
export function RedirectIfAuthenticated() {
  const { user, profile, isLoading } = useAuth();

  // While the profile is still loading, keep the page up rather than guess the
  // destination: a first visit goes somewhere else (below).
  if (user && !isLoading) {
    // A member who has not finished the welcome tour lands in the Round Table,
    // where the tour plays; everyone else goes to their stocks as before.
    const firstVisit = profile !== null && !profile.tour_completed_at;
    return <Navigate to={firstVisit ? "/community" : "/stocks"} replace />;
  }

  return <Outlet />;
}
